import { useMemo } from 'react';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { TextInput } from '~/components/ui/TextInput';
import { rage, useInputAction, useObservable } from '~/rage';
import { InputAction } from '~/shared';
import { useSaveCharacter } from '../../hooks';
import { setInputActionsLocked, useLayoutDispatch } from '../../redux';
import {
	StyledButtonContainer,
	StyledContainer,
	StyledDivider,
	StyledInputsContainer,
} from './FinishRegistration.styled';

const FinishRegistration = () => {
	const dispatch = useLayoutDispatch();
	const modalState = useObservable(rage.modal.getCurrentModal());
	const { handleSave, firstName, setFirstname, lastName, setLastName } =
		useSaveCharacter();

	const buttonDisabled = useMemo(
		() => !firstName.trim() || !lastName.trim(),
		[firstName, lastName],
	);

	useInputAction(InputAction.CommonMenuAccept, () => {
		if (modalState) {
			return;
		}

		handleSave();
	});

	return (
		<StyledContainer data-head-rotation-ignore>
			<Text style={{ fontSize: 16, fontWeight: 500, color: '#ffffff' }}>
				Завершение регистрации
			</Text>
			<StyledDivider style={{ marginTop: 16 }} />
			<StyledInputsContainer>
				<TextInput
					height={40}
					fontSize={16}
					placeholder={'Имя'}
					value={firstName}
					onChange={(e) => setFirstname(e.target.value)}
					onFocus={() => dispatch(setInputActionsLocked(true))}
					onBlur={() => dispatch(setInputActionsLocked(false))}
				/>
				<TextInput
					height={40}
					fontSize={16}
					placeholder={'Фамилия'}
					value={lastName}
					onChange={(e) => setLastName(e.target.value)}
					onFocus={() => dispatch(setInputActionsLocked(true))}
					onBlur={() => dispatch(setInputActionsLocked(false))}
				/>
			</StyledInputsContainer>
			<StyledButtonContainer>
				<Button
					color={ButtonColors.Buy}
					height={ButtonHeight.Height50}
					onClick={handleSave}
					disabled={buttonDisabled}
				>
					<Text>
						{buttonDisabled ? 'Придумайте себе никнейм' : 'Сохранить персонажа'}
					</Text>
				</Button>
			</StyledButtonContainer>
			<StyledDivider style={{ marginTop: 20 }} />
			<Text
				style={{
					fontSize: 14,
					color: 'rgba(255,255,255,0.25)',
					textAlign: 'center',
					marginTop: 20,
				}}
			>
				Вы сможете изменить параметры своего персонажа в любой больницы у
				хирурга!
				<br />
				<br />
				*Просьба не использовать оскорбительные никнеймы для игрока.
			</Text>
		</StyledContainer>
	);
};

export { FinishRegistration };
